import { z } from 'zod';

export const TemplateFormValuesSchema = z.object({
  isActive: z.boolean(),
  description: z.string(),
  businessProcess: z.string().min(1),
  templateName: z.string().min(3),
  applyRules: z.object({
    paymentType: z.string(),
  }),
});

export const StagesConstructorChecklistAttributeSchema = z.object({
  value: z.boolean(),
  isRequired: z.boolean(),
  name: z.string().min(3),
});

export const StagesConstructorEntitySchema = z.object({
  id: z.string().uuid().nullable(),
  name: z.string().min(3),
  checklist: z.array(StagesConstructorChecklistAttributeSchema),
});

export const StagesConstructorListingSchema = z.object({
  bodyFields: z.array(StagesConstructorEntitySchema),
});
